import { ParamsNameDataType } from "./paramsNameTypes.ts";

export const getParamsName: ParamsNameDataType = {
  persona: "persona",
};
